var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mapid-wrapper"}},[_c('v-btn',{attrs:{"small":"","color":"primary","dark":""},on:{"click":_vm.goToListView}},[_vm._v("Back to List View")]),_vm._v(" "),_c('div',{attrs:{"id":"mapid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }